// Client for the JAX-RS RolesResource (org.racs.web.rest.RolesResource) backed by RolesService.
// In dev, requests are proxied to WildFly via the "proxy" field in package.json.

const BASE_URL = '/racs/api/roles';

// Shape returned/accepted by the backend, mirroring org.racs.jpa.Roles.
export type RoleDto = {
  id?: number;
  roleName: string;
  groups: boolean;
  device: boolean;
  hardware: boolean;
  userRoles: boolean;
  profile: boolean;
};

async function parseErrorMessage(res: Response): Promise<string> {
  try {
    const text = await res.text();
    return text || `Request failed with status ${res.status}`;
  } catch {
    return `Request failed with status ${res.status}`;
  }
}

export async function fetchRoles(): Promise<RoleDto[]> {
  const res = await fetch(BASE_URL);
  if (!res.ok) {
    throw new Error(await parseErrorMessage(res));
  }
  return res.json();
}

export async function createRole(role: RoleDto): Promise<RoleDto> {
  const res = await fetch(BASE_URL, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(role),
  });
  if (!res.ok) {
    throw new Error(await parseErrorMessage(res));
  }
  return res.json();
}

export async function deleteRole(id: number): Promise<void> {
  const res = await fetch(`${BASE_URL}/${id}`, { method: 'DELETE' });
  if (!res.ok) {
    throw new Error(await parseErrorMessage(res));
  }
}
